/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LineItem
 */
export interface LineItem {
    /**
     * Line item description
     * @type {string}
     * @memberof LineItem
     */
    desc: string;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    lineItemNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    quantity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    unitPrice?: number | null;
    /**
     * Replacement cost value
     * @type {number}
     * @memberof LineItem
     */
    rcv: number;
    /**
     * 
     * @type {number}
     * @memberof LineItem
     */
    tax?: number | null;
    /**
     * Overhead and profit
     * @type {number}
     * @memberof LineItem
     */
    op?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    rawText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItem
     */
    roomName?: string | null;
}

/**
 * Check if a given object implements the LineItem interface.
 */
export function instanceOfLineItem(value: object): value is LineItem {
    if (!('desc' in value) || value['desc'] === undefined) return false;
    if (!('rcv' in value) || value['rcv'] === undefined) return false;
    return true;
}

export function LineItemFromJSON(json: any): LineItem {
    return LineItemFromJSONTyped(json, false);
}

export function LineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItem {
    if (json == null) {
        return json;
    }
    return {
        
        'desc': json['desc'],
        'lineItemNumber': json['lineItemNumber'] == null ? undefined : json['lineItemNumber'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'rcv': json['rcv'],
        'tax': json['tax'] == null ? undefined : json['tax'],
        'op': json['op'] == null ? undefined : json['op'],
        'rawText': json['rawText'] == null ? undefined : json['rawText'],
        'roomName': json['roomName'] == null ? undefined : json['roomName'],
    };
}

export function LineItemToJSON(json: any): LineItem {
    return LineItemToJSONTyped(json, false);
}

export function LineItemToJSONTyped(value?: LineItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'desc': value['desc'],
        'lineItemNumber': value['lineItemNumber'],
        'quantity': value['quantity'],
        'unit': value['unit'],
        'unitPrice': value['unitPrice'],
        'rcv': value['rcv'],
        'tax': value['tax'],
        'op': value['op'],
        'rawText': value['rawText'],
        'roomName': value['roomName'],
    };
}

